import { DealerLocationID } from "./DealerLocation";

export type NoteSuggestionID = number;

export enum NOTE_SUGGESTION_TYPES {
  CallCustomer = 1,
  RemarkPin = 2,
  WarrantyPin = 3,
  RecallPin = 4,
  Parking = 5
}

export interface NoteSuggestionType {
  note_suggestion_type_id: NOTE_SUGGESTION_TYPES; // Identifier of the note suggestion type
  dealer_location_id: DealerLocationID; // Dealer location identifier
  active: boolean; // Is the note suggestion type active
}

export interface NoteSuggestion {
  created_on: string;
  updated_on: string;
  dealer_location_id: DealerLocationID; // Identifier of the dealer location
  note_suggestion_type_id: NOTE_SUGGESTION_TYPES; // Type of the note suggestion
  ordering: number; // Ordering of the suggestion in the note suggestion list
  content: string; // The note suggestion
  active: boolean; // Is the note suggestion active for the dealer location
}
